import { useContext } from 'react'

import { Form } from 'components/Form'
import { WorkspaceBidderContext } from 'features/globalSetup/contexts/WorkspaceBidderContext'
import { EditBidderFormBody } from './EditBidderFormBody'
import { useUpdateWorkspaceBidder } from './hooks/useUpdateWorkspaceBidder'
import { editSchema, EditSchema, editSchemaDefault } from './schemas/editSchema'

export const EditBidderForm = (): React.JSX.Element => {
  const { formId, loading, setTouched, setValid, workspaceBidder } =
    useContext(WorkspaceBidderContext)

  if (!workspaceBidder) {
    throw Error('Workspace Bidder should be accessible')
  }
  const { bidderCode, id } = workspaceBidder

  const { errors: apiErrors, update } = useUpdateWorkspaceBidder({
    bidderCode,
    id,
  })

  return (
    <Form<EditSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={editSchema}
      schemaDefaults={editSchemaDefault(workspaceBidder)}
    >
      {() => <EditBidderFormBody />}
    </Form>
  )
}
